// extracted by mini-css-extract-plugin
export default {"skeleton":"RRtwUGbOzZr8OOpUlTcU"};